module.exports = __webpack_public_path__ + "img/neutral_face.e7b3dde3.svg";